import { useMutation } from '@apollo/client';
import { gql } from '__generated__/gql';
import { FC } from 'react';

import { FormInput, FormPanelWithReadMode } from 'components/FormPanel';
import EditorFormInput from 'components/QuillEditor/EditorFormInput';

const UPDATE_FUND_MUTATION = gql(`
  mutation UpdateFund(
    $id: ID!
    $name: String!
    $description: String
    $image: Upload
    $closingDate: String!
  ) {
    updateFund(
      id: $id
      name: $name
      description: $description
      image: $image
      closingDate: $closingDate
    ) {
      id
      name
      description
      image
      updatedAt
      closingDate
    }
  }
`);

const UpdateFund: FC<{
  id: string;
  name: string;
  description?: string | null;
  image?: string | null;
  closingDate: string;
}> = ({ id, name, description, image, closingDate }) => {
  const [updateFund, { loading, error }] = useMutation(UPDATE_FUND_MUTATION);

  return (
    <FormPanelWithReadMode
      loading={loading}
      error={error}
      onSubmit={data => {
        updateFund({
          variables: {
            id,
            name: data.name,
            description: data.description,
            image: typeof data.image !== 'string' ? data.image[0] : null,
            closingDate: data.closingDate,
          },
        });
      }}
      title="Information"
    >
      <FormInput type="text" fieldName="name" label="Name" defaultValue={name} />
      <FormInput
        fullWidth
        type="custom"
        fieldName="description"
        label="Description"
        defaultValue={description}
        customInput={EditorFormInput}
      />
      <FormInput fullWidth type="upload" fieldName="image" label="Image" defaultValue={image} />
      <FormInput
        type="date"
        fieldName="closingDate"
        label="Closing Date"
        defaultValue={closingDate}
        helperText="Closing date."
        validators={{
          required: true,
        }}
      />
    </FormPanelWithReadMode>
  );
};

export default UpdateFund;
